import React from 'react';
import './style.scss';

const Roulette = () => {
  return (
    <div className="circle">
      <div className="segment red"></div>
      <div className="segment orange"></div>
      <div className="segment yellow"></div>
      <div className="segment green"></div>
      <div className="segment blue"></div>
      <div className="segment purple"></div>
    </div>
  );
};


export default Roulette;
